import { type PartyData } from '~/types/assets';
import { type DeliveryNote, type Party } from '~/types/deliveryNote';

import { type FormDeliveryNoteFormFields } from '~/modules/ai-parser-review/components/FormDeliveryNote';
import {
  PARTIES,
  REPARSING_DATA_PATHS_MAP,
} from '~/modules/asset-reparsing/constants';

import { getNestedProperty } from '@vestigas/utils';

export const updatePartiesData = (
  draft: DeliveryNote,
  formData: FormDeliveryNoteFormFields,
) => {
  const partiesPaths = Object.fromEntries(
    Object.entries(REPARSING_DATA_PATHS_MAP).filter(([key]) =>
      PARTIES.includes(key),
    ),
  );

  for (const partyPath of Object.values(partiesPaths)) {
    const partyData: PartyData | undefined = getNestedProperty<PartyData>(
      formData,
      partyPath,
    );

    const currentParty: Party = getNestedProperty<Party>(draft, partyPath);

    currentParty.id = partyData?.id;
    currentParty.legalOrganization = partyData?.legalOrganization ?? {};
    currentParty.legalOrganization.name = partyData?.legalOrganization?.name; // Make sure name key always exists b/c the backend requires it
  }
};
